import ReactHtmlParser from "react-html-parser";
import { parserTags } from "./parserTags";
import { Document, Page, StyleSheet, View } from "@react-pdf/renderer";
import React from "react";

const styles = StyleSheet.create({
  page: {
    paddingTop: '36px',
    paddingBottom: '36px',
    paddingLeft: '66px',
    paddingRight: '56px'
  },
  view: {
    paddingBottom: '5px'
  }
});

const getDocument = (htmlItems: string[]) => {
  const Pages = htmlItems.map((htmlItem, htmlIndex) => (
    <Page size="A4" style={styles.page} key={htmlIndex}>{
      // ReactHtmlParser: HTML to ReactElement
      ReactHtmlParser(htmlItem).map((element, elementIndex) => (
        <View key={elementIndex} style={styles.view}>
          {parserTags(element)}
        </View>
      ))
    }</Page>
  ))

  return (
    <Document>{Pages}</Document>
  )
}

export default getDocument